module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('a', {
    staticClass: "x-cta-btn card-link",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(1)]) : _c('div', {
    staticClass: "card"
  }, [((Object.keys(_vm.orders).length > 0)) ? _c('div', _vm._l((_vm.orders), function(order) {
    return _c('div', {
      staticClass: "row card-box card-02",
      staticStyle: {
        "border-bottom": "#eee solid",
        "margin-bottom": "2em"
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/placed/order/' + order.order_no
      }
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image
      }
    }), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "800"
      }
    }, [_vm._v(_vm._s(order.order_items[0].product_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(order.order_details))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(order.order_time_ago) + " >")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No Orders yet")])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "28px"
    }
  }, [_vm._v("Orders")]), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#ff0000",
      "font-weight": "600"
    }
  }), _vm._v(" Re-Order")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e5f8d76"}!./src/pages/PlacedOrders/template.html
// module id = 614
// module chunks = 0